import { call, put, select, take, takeEvery } from 'redux-saga/effects';
import { startAsyncValidation, stopAsyncValidation } from 'redux-form';
import { toast } from 'react-toastify';
import { get } from 'lodash';

import { createApiRequestSaga } from '../../../modules/api/saga';
import { getFormValues } from 'redux-form';
import { ENDPOINTS } from '../../../modules/api/endpoints';

import {
  authResetPassword,
  authResetPasswordError,
  authResetPasswordSuccess,
  authSetGlobalFormErrors,
  authSubmitResetPasswordForm,
} from '../actions';

import { RESET_PASSWORD_FORM } from '../ResetPasswordForm';
import { getType } from 'typesafe-actions';

const resetPasswordSaga = createApiRequestSaga({
  actionSuccess: authResetPasswordSuccess,
  actionError: authResetPasswordError,
});

function* resetPasswordFormWatcher({ payload: { successToastMessage } }: any) {
  const data = yield select(getFormValues(RESET_PASSWORD_FORM));

  yield put(
    authResetPassword({
      url: ENDPOINTS.AUTH.RESET_PASSWORD,
      method: 'post',
      data,
    }),
  );

  yield put(startAsyncValidation(RESET_PASSWORD_FORM));

  yield take([getType(authResetPasswordSuccess)]);
  yield call(toast, successToastMessage, {
    autoClose: 2000,
  });
}

function* watchResetPasswordResults(action: any) {
  const error = get(action, ['payload', 'errors', 'error'], 'unknown');

  yield put(
    authSetGlobalFormErrors({
      formName: RESET_PASSWORD_FORM,
      errors: [error],
    }),
  );

  yield put(stopAsyncValidation(RESET_PASSWORD_FORM, {}));
}

export default function* authResetPasswordSaga() {
  yield takeEvery(getType(authSubmitResetPasswordForm), resetPasswordFormWatcher);
  yield takeEvery([getType(authResetPassword)], resetPasswordSaga);
  yield takeEvery([getType(authResetPasswordSuccess), getType(authResetPasswordError)], watchResetPasswordResults);
}



// WEBPACK FOOTER //
// ./src/containers/Auth/saga/resetPasswordSaga.ts